/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_classification_add_image_examples_for_classification } from '../models/Body_classification_add_image_examples_for_classification';
import type { EmbeddingGenerationStatus } from '../models/EmbeddingGenerationStatus';
import type { Page_ClassificationResponse_ } from '../models/Page_ClassificationResponse_';
import type { Page_ImageResponse_ } from '../models/Page_ImageResponse_';
import type { Page_str_ } from '../models/Page_str_';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClassificationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Classifications
     * @returns Page_ClassificationResponse_ Successful Response
     * @throws ApiError
     */
    public listClassifications({
        classificationName,
        classificationType,
        classificationId,
        classificationHasImages,
        page = 1,
        size = 50,
    }: {
        classificationName?: string,
        classificationType?: string,
        classificationId?: string,
        classificationHasImages?: boolean,
        page?: number,
        size?: number,
    }): CancelablePromise<Page_ClassificationResponse_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/classification/',
            query: {
                'classification_name': classificationName,
                'classification_type': classificationType,
                'classification_id': classificationId,
                'classification_has_images': classificationHasImages,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Unique Classification Types
     * @returns Page_str_ Successful Response
     * @throws ApiError
     */
    public listUniqueClassificationTypes({
        page = 1,
        size = 50,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<Page_str_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/classification/types',
            query: {
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Add Image Examples For Classification
     * @returns any Successful Response
     * @throws ApiError
     */
    public addImageExamplesForClassification({
        classificationId,
        requestBody,
    }: {
        classificationId: string,
        requestBody?: Body_classification_add_image_examples_for_classification,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/classification/{classification_id}/image/example',
            path: {
                'classification_id': classificationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Images For Classification
     * @returns Page_ImageResponse_ Successful Response
     * @throws ApiError
     */
    public listImagesForClassification({
        classificationId,
        url,
        embeddingGenerationStatus,
        imageId,
        sources,
        extraJsonpathExclude,
        extraJsonpathInclude,
        page = 1,
        size = 50,
    }: {
        classificationId: string,
        url?: string,
        embeddingGenerationStatus?: EmbeddingGenerationStatus,
        imageId?: string,
        sources?: Array<string>,
        extraJsonpathExclude?: string,
        extraJsonpathInclude?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<Page_ImageResponse_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/classification/{classification_id}/image',
            path: {
                'classification_id': classificationId,
            },
            query: {
                'url': url,
                'embedding_generation_status': embeddingGenerationStatus,
                'image_id': imageId,
                'sources': sources,
                'extra_jsonpath_exclude': extraJsonpathExclude,
                'extra_jsonpath_include': extraJsonpathInclude,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
